import {loginApi, logoutApi} from '@/api/login'

const state = {
  token: localStorage.getItem('token') || '', // 从本地存储初始化
  info: JSON.parse(localStorage.getItem('userInfo')) || {},
  menuList: []
}

const getters = {
  token: state => state.token,
  userInfo: state => state.info
}

const mutations = {
  setToken(state, token) {
    state.token = token
    localStorage.setItem('token', token) // 持久化存储
  },
  setInfo(state, info) {
    state.info = info
    localStorage.setItem('userInfo', JSON.stringify(info))
  },
  setMenuList(state, menuList) {
    state.menuList = menuList
  },
  clearAuth(state) {
    state.token = ''
    state.info = {}
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  async login({commit, dispatch}, params) {
    try {
      const {data} = await loginApi(params)
      commit('setToken', data.token)
      commit('setInfo', data)
      return data
    } catch (error) {
      commit('clearAuth')
      throw error
    }
  },
  async loginOut({commit}, redirectLogin = true) {
    try {
      const {code} = await logoutApi()
      if (code == 200) {
        commit('clearAuth')
        // 使用路由跳转代替页面刷新
        if (redirectLogin && window.location.pathname !== '/login') {
          window.location.href = '/login'
        }
      }
    } catch (error) {
      commit('clearAuth')
      throw error
    }
  },
  clearAuthAndUserInfo({commit}) {
    commit('clearAuth')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
